import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const Notification = Loadable(lazy(() => import('views/notification')));
const Users = Loadable(lazy(() => import('views/users/')));
const User = Loadable(lazy(() => import('views/users/Profile/index')));
const CreateContent = Loadable(lazy(() => import('views/content/index')));
const ListContent = Loadable(lazy(() => import('views/content/content-list/index')));
const Schedule = Loadable(lazy(() => import('views/schedule/index')));
const Organization = Loadable(lazy(() => import('views/organization/')));
const TeacherDue = Loadable(lazy(() => import('views/payment')));
const Payment = Loadable(lazy(() => import('views/payment/details')));
const UserManual = Loadable(lazy(() => import('views/user-manual/index')));
const Feedback = Loadable(lazy(() => import('views/feedback/index')));
const System = Loadable(lazy(() => import('views/system/index')));
const Symptom = Loadable(lazy(() => import('views/symptoms/index')));
const Disease = Loadable(lazy(() => import('views/diseases/index')));
const DiseaseAnalytics = Loadable(lazy(() => import('views/disease-analytics/index')));
const AddAnimal = Loadable(lazy(() => import('views/add-animal/index')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <DiseaseAnalytics />
        },
        {
            path: '/create-content',
            element: <CreateContent />
        },
        {
            path: '/create-content/tabIndex=:tabIndex',
            element: <CreateContent />
        },
        {
            path: '/list-content',
            element: <ListContent />
        },
        {
            path: '/schedule-content',
            element: <Schedule />
        },
        {
            path: '/notification',
            element: <Notification />
        },
        {
            path: '/users',
            element: <Users />
        },
        {
            path: '/user/:id',
            element: <User />
        },
        {
            path: '/user-manual',
            element: <UserManual />
        },
        {
            path: '/feedback',
            element: <Feedback />
        },
        {
            path: '/system',
            element: <System />
        },
        {
            path: '/symptom/cow',
            element: <Symptom />
        },
        {
            path: '/symptom/goat',
            element: <Symptom />
        },
        {
            path: '/disease/cow',
            element: <Disease />
        },
        {
            path: '/disease/goat',
            element: <Disease />
        },
        {
            path: '/analytics',
            element: <DiseaseAnalytics />
        },
        {
            path: '/add-animal',
            element: <AddAnimal />
        }
    ]
};

export default MainRoutes;
